import { SVGProps } from "react";

export type AmenitySvgProps = SVGProps<SVGSVGElement>;

export function AmenitySvg({ children, className, ...props }: AmenitySvgProps) {
  return (
    <svg
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      className={className}
      {...props}
    >
      {children}
    </svg>
  );
}
